import { Box, Stack } from "@mui/material";

// Simple logo component for SVG icons
export function PaymentLogoBadge({ name, src }: { name: string; src: string }) {
  return (
    <Box
      component="img"
      src={src}
      alt={name}
      role="img"
      aria-label={name}
      sx={{
        height: 28,
        width: "auto",
        display: "block",
        cursor: "pointer",
        transition: "transform 0.2s ease-in-out",
        "&:hover": {
          transform: "scale(1.1)",
        },
      }}
    />
  );
}

// Default export renders the row of payment options
export default function PaymentOptions() {
  const logos = [
    { name: "MasterCard", src: "/WebIcons/mastercard.png" },
    { name: "VISA", src: "/WebIcons/visa.png" },
  ];

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      {logos.map(({ name, src }) => (
        <PaymentLogoBadge key={name} name={name} src={src} />
      ))}
    </Stack>
  );
}
